$(document).ready(() => {
  const bundle = async (ID, productTitle, productSKU, var_id) => {
    let formData1 = {
      'items': [{
        'id': ID,
        'quantity': 1,
        'properties': {
          'Product': productTitle,
          '_Product SKU': productSKU,
        }
      }]
    };
    let addToCartForm = document.querySelector('form[action="/cart/add"]');
    let formData2 = new FormData(addToCartForm);
    console.log(formData2);

    if (window
      .location
      .href
      .indexOf("#only-frame") > -1) {
      const frame = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData1)
      }).then(response => {
        return response.json();
      });

      let props = {};

      $.getJSON('/cart.js', function (cart) {
        for(let i = 0; i < cart.items.length; i++){
          if(cart.items[i].id == var_id){
            props = Object.assign({}, cart.items[i].properties);
              let qty = cart.items[i].quantity - 1;
              jQuery.ajax({
                type: 'POST',
                url: '/cart/change.js',
                data: {
                  "id": var_id,
                  "quantity": qty
                },
                dataType: 'json',
                success: function(result) {
                  console.log(result, "CHANGED");
                }, error: function(jqxhr, status, exception) {

                }
              }).then(function (){
                props.Frame = "Framed";
                props.Framed = "";
                console.log("props: ", props);
                jQuery.ajax({
                  type: 'POST',
                  url: '/cart/add.js',
                  data: {
                    "id": var_id,
                    "quantity": 1,
                    'properties': props
                  },
                  dataType: 'json',
                  success: function(result) {
                    console.log(" SUCCESS ");
                  }, error: function(jqxhr, status, exception) {

                  }
                })
              });
          }
        }
      });

      $.getJSON('/cart.js', function (cart) {
        console.log("Cart After: ", cart);
      })

      console.log("Frame and product");
      frame;

      history.pushState("", document.title, window.location.pathname + window.location.search);
    } else {
      console.log("Product");

      const frame = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData1)
      }).then(function(response) {
        return response.json();
      }).then(function(json) {
        //console.log(json)
      }).catch(function(err) {
        //console.error(err)
      });

      const product = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData2
      }).then(function(response) {
         if (response.status >= 400) {
          }
        return response.json();
      }).then(function(json) {
        //console.log(json);

        if (json.status == 422) {
         $('.main-product-form').addClass('hasError');
         console.log('haserror');
         $('.product-form__recipient-error-message-wrapper').removeAttr('hidden');
         $('.product-form__recipient-error-message-wrapper ul').empty();
         $('.product-form__recipient-error-message-wrapper ul').append("<li>"+json.errors.email[0]+"</li>");
         $('.form__message--email').removeClass('hidden');
         $('.form__message--email .error-message').empty();
         $('.form__message--email .error-message').append(json.errors.email[0]);
         $('html, body').animate({
              scrollTop: $(".product-form__recipient-error-message-wrapper").offset().top
          }, 500);
       } else {
          $('.main-product-form').removeClass('hasError');
          if ($('.recipient-form').length) {
            $('.product-form__recipient-error-message-wrapper').attr('hidden', true);
            $('.form__message--email').addClass('hidden')
          }
       }
      }).catch(function(err) {
        console.error(err)
      });

      frame;
      product;
    }

    console.log('done');
  }

  $(function () {
    $('#product-submit').click(function (e) {
      e.preventDefault();

      let selectSize = $('.options-size option:selected').text().split(' /')[0];
      let selectSKU = $('.options-size option:selected').attr('data-sku');
      var product = $('#Frame').attr('data-product');
      var variant = $('.options-frame option:not(.hide):selected').attr("data-variant");
      var var_id = $('.main-product__select option:selected').attr("data-variant-id");
      console.log("var_id:", var_id );
      bundle(variant, product, selectSKU, var_id);
    });

    if (window
      .location
      .href
      .indexOf("#only-frame") > -1) {
      $('.options-frame option:not(.hide)[value="Framed"]').prop('selected', true);
      $('#is-framed').val("Framed");
      $('.product__media').addClass('product__media--black');
    }
  });
});
